import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../api";

function CustomerView() {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCustomer = async () => {
    try {
      const res = await api.get(`/jeweller-customers/${id}`);
      setCustomer(res.data);
    } catch (err) {
      console.error("Error fetching customer:", err.response || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, [id]);

  if (loading)
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <div className="w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  if (!customer)
    return (
      <div className="p-8 text-center text-red-500 font-medium text-lg">
        Customer not found!
      </div>
    );

  return (
    <div className="p-8 max-w-3xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="h-16 w-16 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 text-2xl font-semibold shadow-inner">
          {customer.full_name?.charAt(0)?.toUpperCase() || "C"}
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            {customer.full_name}
          </h1>
          <p className="text-sm text-gray-500">
            Added on {new Date(customer.created_at).toLocaleDateString()}
          </p>
        </div>
      </div>

      {/* Details Card */}
      <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 space-y-6">
        <section>
          <h2 className="text-lg font-semibold text-purple-600 border-b pb-2 mb-3">
            Personal Details
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            <p><span className="font-medium">Full Name:</span> {customer.full_name}</p>
            <p><span className="font-medium">Email:</span> {customer.email || "—"}</p>
            <p><span className="font-medium">Mobile:</span> {customer.mobile}</p>
            <p><span className="font-medium">Customer Type:</span> {customer.customer_type}</p>
            <p><span className="font-medium">Date of Birth:</span> {customer.dob || "—"}</p>
            <p><span className="font-medium">Anniversary:</span> {customer.anniversary || "—"}</p>
            <p><span className="font-medium">Aadhar Number:</span> {customer.aadhar_number || "—"}</p>
            <p><span className="font-medium">Status:</span>{" "}
              <span
                className={`px-2 py-1 rounded-full text-xs font-semibold ${customer.user_status === "Active"
                    ? "bg-green-300 text-gray-600"
                    : "bg-red-300 text-gray-600"
                  }`}
              >
                {customer.status || "Active"}
              </span>
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-purple-600 border-b pb-2 mb-3">
            Address Details
          </h2>
          <div className="space-y-2 text-gray-700">
            <p><span className="font-medium">Permanent Address:</span> {customer.permanent_address || "—"}</p>
            <p><span className="font-medium">Residence Address:</span> {customer.residence_address || "—"}</p>
          </div>
        </section>

        {customer.staff_name && (
          <section>
            <h2 className="text-lg font-semibold text-purple-600 border-b pb-2 mb-3">
              Assigned Staff
            </h2>
            <p className="text-gray-700">{customer.staff_name}</p>
          </section>
        )}

      </div>

      {/* Action Buttons */}
      <div className="mt-8 flex justify-end gap-3">
        <Link
          to="/jewellers/customers"
          className="px-5 py-2.5 bg-gray-100 text-gray-700 rounded-lg shadow hover:bg-gray-200 transition-all duration-200"
        >
          Back
        </Link>
        <Link
          to={`/jewellers/customers/${customer.id}/edit`}
          className="px-5 py-2.5 bg-gradient-to-r from-purple-600 to-fuchsia-600 text-white rounded-lg shadow hover:from-purple-700 hover:to-fuchsia-700 transition-all duration-200"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}

export default CustomerView;
